import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'TaxationType';
const ENDPOINT = `/taxation-types/`;

@Injectable({
    providedIn: 'root'
})
export class TaxationTypeService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
